const sr = {
  'app.name': 'Smart Cabinet Studio',
  'auth.email': 'Email',
  'auth.password': 'Lozinka',
  'auth.login': 'Prijava',
  'auth.logout': 'Odjava',
  'auth.forgot': 'Zaboravljena lozinka?',
  'auth.resetTitle': 'Reset lozinke',
  'auth.resetSend': 'Pošalji uputstvo',
  'auth.newPassword': 'Nova lozinka (min. 12 znakova)',
  'auth.setPassword': 'Postavi lozinku',
  'auth.backToLogin': 'Nazad na prijavu',
  'auth.inviteTitle': 'Prihvatanje pozivnice',
  'auth.name': 'Ime i prezime',
  'auth.accept': 'Prihvati',
  'auth.changePassword': 'Promjena lozinke',
  'auth.currentPassword': 'Trenutna lozinka',
  'auth.passwordChanged': 'Lozinka je promijenjena. Ostale sesije su odjavljene.',
  'auth.passwordSet': 'Lozinka je postavljena. Možete se prijaviti.',
  'dash.projects': 'Projekti',
  'dash.new': 'Novi projekat',
  'dash.search': 'Pretraga po nazivu ili klijentu…',
  'dash.active': 'Aktivni',
  'dash.archived': 'Arhiva',
  'dash.trash': 'Korpa',
  'dash.empty': 'Nema projekata.',
  'dash.client': 'Klijent',
  'dash.modified': 'Izmijenjeno',
  'dash.revision': 'Revizija',
  'dash.status': 'Status',
  'dash.open': 'Otvori',
  'dash.duplicate': 'Dupliraj',
  'dash.rename': 'Preimenuj',
  'dash.archive': 'Arhiviraj',
  'dash.unarchive': 'Vrati iz arhive',
  'dash.delete': 'Obriši',
  'dash.restore': 'Vrati',
  'dash.demo': 'DEMO',
  'dash.name': 'Naziv',
  'dash.create': 'Kreiraj',
  'dash.cancel': 'Otkaži',
  'save.saved': 'Snimljeno na server',
  'save.dirty': 'Nesnimljene izmjene',
  'save.saving': 'Snimanje…',
  'save.offline': 'Offline — izmjene su sačuvane samo lokalno',
  'save.conflict': 'Konflikt revizije',
  'save.error': 'Greška pri snimanju',
  'save.expired': 'Sesija je istekla — prijavite se ponovo; izmjene su lokalno sačuvane',
  'save.readonly': 'Samo pregled',
  'save.save': 'Snimi',
  'editor.undo': 'Poništi',
  'editor.redo': 'Ponovi',
  'editor.add': 'Dodaj element',
  'editor.scene': 'Scena',
  'editor.properties': 'Svojstva',
  'editor.issues': 'Provjere',
  'editor.parts': 'Dijelovi',
  'editor.cutlist': 'Krojna lista',
  'editor.edges': 'Kant',
  'editor.noSelection': 'Ništa nije selektovano. Kliknite element u sceni ili listi.',
  'editor.perspective': 'Perspektiva',
  'editor.ortho': 'Ortogonalno',
  'editor.front': 'Naprijed',
  'editor.back': 'Nazad',
  'editor.left': 'Lijevo',
  'editor.right': 'Desno',
  'editor.top': 'Odozgo',
  'editor.frame': 'Uokviri selekciju',
  'editor.grid': 'Mreža',
  'editor.xray': 'X-ray',
  'editor.exploded': 'Rastavljeno',
  'editor.labels': 'ID oznake',
  'editor.edgeView': 'Prikaz kanta',
  'editor.openFronts': 'Otvori fronte',
  'editor.duplicate': 'Dupliraj',
  'editor.mirror': 'Ogledalo',
  'editor.delete': 'Obriši',
  'editor.hide': 'Sakrij',
  'editor.lock': 'Zaključaj',
  'editor.downloadCsv': 'Preuzmi CSV (server, snimljena revizija)',
  'editor.recoverTitle': 'Pronađene su lokalne nesnimljene izmjene',
  'editor.recoverApply': 'Vrati lokalne izmjene',
  'editor.recoverDiscard': 'Odbaci',
  'editor.conflictTitle': 'Projekat je izmijenjen na drugom mjestu',
  'editor.conflictText': 'Server ima noviju reviziju. Vaše izmjene nisu prepisale tuđe. Izaberite kako dalje:',
  'editor.conflictLoad': 'Učitaj serversku verziju (moje izmjene ostaju u lokalnom journalu)',
  'editor.conflictCopy': 'Snimi moju verziju kao novi projekat',
  'editor.versions': 'Revizije',
  'editor.backToDash': 'Projekti',
} as const;

export type MsgKey = keyof typeof sr;

const en: Record<MsgKey, string> = {
  'app.name': 'Smart Cabinet Studio',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.login': 'Sign in',
  'auth.logout': 'Sign out',
  'auth.forgot': 'Forgot password?',
  'auth.resetTitle': 'Reset password',
  'auth.resetSend': 'Send instructions',
  'auth.newPassword': 'New password (min. 12 characters)',
  'auth.setPassword': 'Set password',
  'auth.backToLogin': 'Back to sign in',
  'auth.inviteTitle': 'Accept invitation',
  'auth.name': 'Full name',
  'auth.accept': 'Accept',
  'auth.changePassword': 'Change password',
  'auth.currentPassword': 'Current password',
  'auth.passwordChanged': 'Password changed. Other sessions were signed out.',
  'auth.passwordSet': 'Password set. You can sign in now.',
  'dash.projects': 'Projects',
  'dash.new': 'New project',
  'dash.search': 'Search by name or client…',
  'dash.active': 'Active',
  'dash.archived': 'Archive',
  'dash.trash': 'Trash',
  'dash.empty': 'No projects.',
  'dash.client': 'Client',
  'dash.modified': 'Modified',
  'dash.revision': 'Revision',
  'dash.status': 'Status',
  'dash.open': 'Open',
  'dash.duplicate': 'Duplicate',
  'dash.rename': 'Rename',
  'dash.archive': 'Archive',
  'dash.unarchive': 'Unarchive',
  'dash.delete': 'Delete',
  'dash.restore': 'Restore',
  'dash.demo': 'DEMO',
  'dash.name': 'Name',
  'dash.create': 'Create',
  'dash.cancel': 'Cancel',
  'save.saved': 'Saved to server',
  'save.dirty': 'Unsaved changes',
  'save.saving': 'Saving…',
  'save.offline': 'Offline — changes stored locally only',
  'save.conflict': 'Revision conflict',
  'save.error': 'Save failed',
  'save.expired': 'Session expired — sign in again; changes are kept locally',
  'save.readonly': 'Read only',
  'save.save': 'Save',
  'editor.undo': 'Undo',
  'editor.redo': 'Redo',
  'editor.add': 'Add unit',
  'editor.scene': 'Scene',
  'editor.properties': 'Properties',
  'editor.issues': 'Checks',
  'editor.parts': 'Parts',
  'editor.cutlist': 'Cut list',
  'editor.edges': 'Edge banding',
  'editor.noSelection': 'Nothing selected. Click a unit in the scene or the list.',
  'editor.perspective': 'Perspective',
  'editor.ortho': 'Orthographic',
  'editor.front': 'Front',
  'editor.back': 'Back',
  'editor.left': 'Left',
  'editor.right': 'Right',
  'editor.top': 'Top',
  'editor.frame': 'Frame selection',
  'editor.grid': 'Grid',
  'editor.xray': 'X-ray',
  'editor.exploded': 'Exploded',
  'editor.labels': 'ID labels',
  'editor.edgeView': 'Edge view',
  'editor.openFronts': 'Open fronts',
  'editor.duplicate': 'Duplicate',
  'editor.mirror': 'Mirror',
  'editor.delete': 'Delete',
  'editor.hide': 'Hide',
  'editor.lock': 'Lock',
  'editor.downloadCsv': 'Download CSV (server, saved revision)',
  'editor.recoverTitle': 'Unsaved local changes found',
  'editor.recoverApply': 'Restore local changes',
  'editor.recoverDiscard': 'Discard',
  'editor.conflictTitle': 'Project was changed elsewhere',
  'editor.conflictText': 'The server has a newer revision. Your changes did not overwrite it. Choose how to continue:',
  'editor.conflictLoad': 'Load server version (my changes stay in the local journal)',
  'editor.conflictCopy': 'Save my version as a new project',
  'editor.versions': 'Revisions',
  'editor.backToDash': 'Projects',
};

const dictionaries = { sr, en } as const;
export type Lang = keyof typeof dictionaries;

let lang: Lang = (() => {
  try {
    return (localStorage.getItem('scs.lang') as Lang) === 'en' ? 'en' : 'sr';
  } catch {
    return 'sr';
  }
})();

export function getLang(): Lang {
  return lang;
}

export function setLang(l: Lang) {
  lang = l;
  try {
    localStorage.setItem('scs.lang', l);
  } catch {
    /* ignore */
  }
  document.documentElement.lang = l === 'sr' ? 'sr-Latn' : 'en';
  window.dispatchEvent(new Event('scs:lang'));
}

export function t(key: MsgKey): string {
  return dictionaries[lang][key];
}
